import React from 'react';
import { Modal, Button } from 'antd';
import { CloseOutlined } from '@ant-design/icons';
import IconError from '../../icons/iconError/iconError';
import './styleAlertModal.css';

interface AlertModalProps {
    open: boolean;
    onOk: () => void;
    onCancel: () => void;
    children?: React.ReactNode;
}

const AlertModal: React.FC<AlertModalProps> = ({ open, onOk, onCancel, children }) => {
    return (
        <Modal
            title={
                <div className="titleAlert">
                    <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                        <IconError style={{ flex: '0 0 auto' }} />
                        <span className="spanAlert">Сработала тревога</span>
                    </div>
                    <CloseOutlined onClick={onCancel} className="closeBut_Alert" />
                </div>
            }
            className="alert_modal"
            open={open}
            mask={false}
            width={0}
            onOk={onOk}
            onCancel={onCancel}
            closable={false}
            footer={
                <Button className="buttonAlertClose" onClick={onCancel}>Закрыть</Button>
            }
            style={{ top: 48, right: 48, position: 'fixed' }}
        >
            <div className="bodyAlertText">{children || <span>Обратите внимание на устройство 123</span>}</div>
        </Modal>
    );
};

export default AlertModal; 